/** @format */

import React, { useState, useRef } from 'react';
import { Box, Grid } from '@mui/material';
import {
  PageContainer,
  TableComponents,
  SimpleDialog,
  FilterPod,
} from 'components';
import { useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns } from './Columns';
import { serviceCallListApi, serviceSetRelatedServiceApi } from '../../services/WebServiceServices';
import InitFilters from '../constants/InitFiltering';
import { useStyles } from '../Style';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const ListWebService = () => {
  // -- STATES --//
  const [filters, setFilters] = useState(InitFilters());
  const [openDialog, setOpenDialog] = useState(false);
  const [fullWidthDialog, setFullWidthDialog] = useState(true);
  const [loadingDialog, setLoadingDialog] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'myWebServiceListPage',
      'subMyWebServiceListBtn',
      'changeStatsMyWebServiceListBtn',
      'editMyWebServiceListBtn',
      'detailMyWebServiceListBtn'
    ])
  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
  });

  // -- HOOKS --//
  const classes = useStyles();
  const tableRef = useRef();
  const navigate = useNavigate();

  // -- API REQUESTS --//
  const getWebServices = async (query) => {
    setLoading(true);
    const params = {
      offset: query ? query?.pageNumber * query?.pageSize : page * size,
      size: query ? query?.pageSize : size,
    };
    const filterVOS = toFilterVOS([...filters]);
    const filterQueries = filterVOStoQueryStr(filterVOS);

    // exception on usage of showDisable and showEnable in serviceCall api
    if (filterQueries?.hasOwnProperty('showEnable')) {
      if (filterQueries.showEnable === 'true' || filterQueries.showEnable === true) {
        filterQueries.showDisable = false;
      } else {
        filterQueries.showEnable = false;
        filterQueries.showDisable = true;
      }
    } else {
      filterQueries.showEnable = true;
      filterQueries.showDisable = true;
    }
    // end exception

    try {
      const data = await serviceCallListApi({ ...filterQueries, ...params });
      const list = createData(data.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      return {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: data.count,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const createData = (data, params) => {
    const list = data.map((item, key) => {
      const webServices = item;
      return {
        num: params?.page * params?.pageSize + key + 1,
        name: webServices.name,
        id: webServices.id,
        serviceVersion: webServices.serviceVersion,
        enable: webServices.enable,
        providerBusiness: webServices?.providerBusiness?.name || '-',
        price: webServices.scPriceCalculationType === 'FIXED' ? webServices.price : '',
        calculationMethod:
          webServices.scPriceCalculationType === 'FIXED' ? 'ثابت' : 'در هر فراخوانی',
        meta: {
          scGuildCode: webServices.scGuildCode,
          scNamespace: webServices.scNamespace ? webServices.scNamespace : null, // *  فضای نام در این بخش وارد میشود که معمولا همان اکشن میباشد
          scUrl: webServices.scUrl,
          scMethodName: webServices.scMethodName,
          scInputParams: item?.scInputParams, // body  ----- JSON.stringify(webServices.serviceParams);
          scHeaderParams: item?.scHeaderParams ?? [],
          scType: webServices.scType,
          scEnName: webServices.scEnName,
          scProvider: webServices.scProvider,
          scFaName: webServices.scFaName,
          scHttpVerb: webServices.scHttpVerb,
          scPriceCalculationType: webServices.scPriceCalculationType,
          scPriceHeader: webServices.scPriceHeader ? webServices.scPriceHeader : '',
          scPriceInquiryUrl: webServices.scPriceInquiryUrl ? webServices.scPriceInquiryUrl : '',
          scPaymentType: webServices.scPaymentType,
          scStakeholderList: webServices.scStakeholderList,
          scAutoApprove: webServices.scAutoApprove,
          scClientId: webServices.scClientId,
          scSuccessfulResult: webServices.scSuccessfulResult,
        },
      };
    });

    return list;
  };

  const showServiceSet = async ({ id, name }) => {
    setFullWidthDialog(false);
    setLoadingDialog(true);
    setOpenDialog(true);

    let content;

    try {
      const res = await serviceSetRelatedServiceApi(id);

      if (res.result.rows.length) {
        content = (
          <div className={classes.serviceSetModal}>
            {res.result.rows.map((data, index) => (
              <Chip variant="outlined" color="primary" label={data.cols[1]} key={index} />
            ))}
          </div>
        );
      } else {
        content = (
          <div className={classes.serviceSetModal}>
            برای وب سرویس "{name}" مجموعه سرویسی تعریف نشده است.
          </div>
        );
      }
    } catch (e) { }

    setLoadingDialog(false);

    setDialogContent({
      title: `مجموعه سرویس های سرویس "${name}"`,
      content,
    });

    setOpenDialog(true);
  };
  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const showDetailsWebService = (rowData) => {
    setFullWidthDialog(true);
    let data = rowData.meta;
    data = JSON.stringify(data, null, 5);

    setDialogContent({
      title: `جزییات وب سرویس "${rowData.name}"`,
      content: (
        <div style={{ direction: 'ltr', textAlign: 'left' }}>
          <pre>{data}</pre>
        </div>
      ),
    });

    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setDialogContent({ title: '', content: '' });
    setOpenDialog(false);
  };

  const edit = (rowData) => {
    navigate(`/services/web-services/${rowData.id}/edit`);
  };

  const hint =
    'در این بخش می‌توانید وب سرویس های تعریف‌شده را ملاحظه و در صورت لزوم سرویس مورد نظر خود را ویرایش نمایید.';

  return (
    <PageContainer title="لیست سرویس‌های من" description={hint} breadcrumbs={constBreadCrumbsTitle.WEBSERVICE_LIST}>
      {actionsList['myWebServiceListPage'] && (
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <TableComponents
              columns={columns(showServiceSet, showDetailsWebService, edit, actionsList)}
              data={getWebServices}
              ref={tableRef}
              isLoading={loading}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getWebServices(ps);
              }}

            />
          </Grid>
        </Grid>
      )}
      <SimpleDialog
        fullWidth={fullWidthDialog}
        maxWidth="xl"
        open={openDialog}
        title={dialogContent.title}
        onClose={handleCloseDialog}
        loading={loadingDialog}
      >
        {dialogContent.content}
      </SimpleDialog>
    </PageContainer>
  );
};

export default ListWebService;
